import { AppAuthorization, resetPolicy, tenantName } from './app.authorization';

export const PasswordResetUrl = 'https://login.microsoftonline.com/' + tenantName.value +'/oauth2/v2.0/authorize?' +
    'p=' + resetPolicy.value +
    '&client_id=' + AppAuthorization.clientId +
    '&nonce=defaultNonce' +
    '&redirect_uri=' + AppAuthorization.redirectUri +
    '&scope=openid' +
    '&response_type=id_token' +
    '&prompt=login';